module.exports = __webpack_public_path__ + "img/dzbxzc.c21d47b2.png";